export default function Blog() {
	return <h1>Blog</h1>
}